import { GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton } from '@mui/x-data-grid';

function TableToolbar() {
	return (
		<GridToolbarContainer>
			<GridToolbarFilterButton placeholder={undefined} onResize={undefined} onResizeCapture={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
			<GridToolbarColumnsButton touchRippleRef={undefined} placeholder={undefined} onResize={undefined} onResizeCapture={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
			<GridToolbarExport csvOptions={{ fileName: "products", delimiter: ';' }} touchRippleRef={undefined} />
		</GridToolbarContainer>
	);
}

export default TableToolbar;